class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(()=>{if(window.ecCartUpsell)return;window.ecCartUpsell=!0;let t=!1,e=!1;const a=t=>{const a=t.target;"submit"===t.type?a.matches("form")&&!a.matches("[data-ec-cart-upsell]")&&"checkout"===t.submitter?.name&&(e=!0):a.closest?.('[name="checkout"],a[href*="/checkout"],.ec-wallets,shopify-accelerated-checkout-cart')&&(e=!0)};document.addEventListener("click",a,!0),document.addEventListener("submit",a,!0),addEventListener("pageshow",()=>{e=!1}),document.addEventListener("submit",async a=>{const o=a.target;if(!o.matches?.("[data-ec-cart-upsell]"))return;if(a.preventDefault(),t||"true"===o.dataset.ecConfirmed)return;const r=o.closest("cart-drawer"),n=o.querySelector('button[type="submit"]'),s=o.querySelector("[data-ec-upsell-status]"),c=n.textContent,i=Number(o.dataset.ecVariant),d=Number(o.dataset.ecProduct);if(!r||!Number.isSafeInteger(i)||i<=0||"function"!=typeof r.renderContents)return void(s.textContent=o.dataset.error);t=!0,e=!1,n.disabled=!0,n.textContent=o.dataset.loading,s.textContent="";let u=!1,l=!1,f=!1,h=o.dataset.root||window.Shopify?.routes?.root||"/";h.endsWith("/")||(h+="/");const p=r.getSectionsToRender().map(t=>t.id);async function m(t){let a=t.sections;if(!a||p.some(t=>!a[t])){const t=await fetch(h+"?sections="+encodeURIComponent(p.join(",")),{headers:{Accept:"application/json"},cache:"no-store"});if(!t.ok)throw Error("refresh");a=await t.json()}if(p.some(t=>!a[t]))throw Error("refresh");!e&&r.isConnected&&(r.renderContents({...t,sections:a}),requestAnimationFrame(()=>{if(e||!r.classList.contains("active"))return;const t=r.querySelector("#CartDrawer-Checkout");"function"==typeof trapFocus?trapFocus(r.querySelector("#CartDrawer"),t):t?.focus({preventScroll:!0})}))}try{const t=await fetch(h+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:i,quantity:1}],sections:p,sections_url:location.pathname})});if(!t.ok)throw f=!0,Error("add");const e=await t.json();if(e.status>=400)throw f=!0,Error("add");u=!0,o.dataset.ecConfirmed="true",await m(e)}catch(t){if(!u&&!f)try{const t=await fetch(h+"cart.js",{headers:{Accept:"application/json"},cache:"no-store"});if(!t.ok)throw Error("cart");const e=await t.json();u=e.items.some(t=>t.product_id===d||t.variant_id===i),u?(o.dataset.ecConfirmed="true",await m(e)):l=!0}catch{l=!0}o.isConnected&&!e&&(s.textContent=u?o.dataset.refresh:l?o.dataset.uncertain:o.dataset.error)}finally{t=!1,o.isConnected&&(n.disabled=u||l,n.textContent=u?o.dataset.added:c)}})})();
